export var SelectionHelper = function SelectionHelper() {};

SelectionHelper.fromPosition = function (position) {
  return {
    start: position,
    end: position,
    direction: 'none'
  };
};

SelectionHelper.backward = function (start, end) {
  return {
    start: start,
    end: end,
    direction: 'backward'
  };
};

SelectionHelper.forward = function (start, end) {
  return {
    start: start,
    end: end,
    direction: 'forward'
  };
};